<template>
<div>
  <img v-if="overlay.imageURL && !videoFile" class="video-frame cover" :src="overlay.imageURL"/>
  <video v-else-if="videoFile && overlay" 
  muted
  autoplay
  loop
  >
  <source :src="overlay.imageURL" type="video/mp4">
</video>
  <iframe
    v-else
    :src="closedCaptions && cc?cc:src"
    frameborder="0"
    autoplay
    allowfullscreen
    allow="autoplay;fullscreen"
    class="video-frame"
  ></iframe>
  </div>
</template>

<script>
export default {
  name: "bgl-embed",
  props: { src: String, cc:String,
  overlay:[Object,String]},
  computed:{
    closedCaptions(){
      return window.location.href.match("cc.tinaswishbenefit")
    },
    videoFile(){
      if (!this.overlay)return false
      return this.overlay.imageURL.match(/mp4|mpeg|avi/)
    }
  }
};
</script>

<style scoped>
video{
  width: 100%;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 0 rgba(0, 0, 0, 0.15);
}
.cover{
  height: auto;
  max-height: none;
}
</style>